module.exports = __webpack_public_path__ + "static/website-app-service-screenshot@3x-0a8081547567b747f436dfaf8eab280f.png";